import React from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { grey, blueGrey } from '@mui/material/colors';
import Helmet from 'react-helmet';
import { useSearchParams } from 'react-router-dom';

import { Logo } from '../../components';
import { PasswordResetRequestForm } from './PasswordResetRequestForm';
import { PasswordUpdateForm } from './PasswordUpdateForm';

const containerStyles = { height: '100%', display: 'flex' };
const rootStyles = { width: '100%', height: '100%', background: blueGrey[900] };
const stackStyles = {
  boxShadow: `0 8px 24px ${grey[800]}`,
  width: '100%',
  bgcolor: 'background.paper',
  borderRadius: 2,
};

const ResetPassword = React.memo(() => {
  const [params] = useSearchParams();
  const id = params.get('id');
  const token = params.get('token');
  const isPasswordUpdatePage = !!id && !!token;

  return (
    <div style={rootStyles}>
      <Helmet title="Reset password"></Helmet>
      <Container maxWidth="xs" sx={containerStyles}>
        <Stack
          spacing={2}
          alignItems="flex-start"
          justifyContent="center"
          sx={stackStyles}
          px={4}
          pt={8}
          pb={12}
          mt={18}
          mb="auto"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            width="100%"
          >
            <Logo size={92} />
            <Typography textAlign="center" fontWeight="bold" variant="h2">
              Acolyte
            </Typography>
          </Stack>
          {isPasswordUpdatePage ? (
            <PasswordUpdateForm id={id!} token={token!} />
          ) : (
            <PasswordResetRequestForm />
          )}
        </Stack>
      </Container>
    </div>
  );
});

export { ResetPassword };
